import React, { useEffect, useState } from "react";
import BrochureImage from "../../../assets/images/bronchureimage.svg";

interface BrochureData {
  id: number;
  title: string;
  file: {
    url: string;
  }
  imageUrl?: string;
}

const WantToLearnMore: React.FC = () => {
  const [brochureData, setBrochureData] = useState<BrochureData | null>(null);

  useEffect(() => {
    // Placeholder API call to fetch brochure data
    const fetchBrochureData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL || ""}/api/bronchure?populate=*`
        );

        if (response.ok) {
          const data = await response.json();
          setBrochureData(data.data);
        } else {
          // Fallback data
          setBrochureData({
            id: 1,
            title: "CBR Program Brochure",
            file: { url: "" },
            imageUrl: "",
          });
        }
      } catch (error) {
        console.error("Error fetching brochure data:", error);
        // Fallback data on error
        setBrochureData({
          id: 1,
          title: "CBR Program Brochure",
          file: { url: "" },
          imageUrl: "",
        });
      }
    };

    fetchBrochureData();
  }, []);

  const handleDownload = async () => {
    if (!brochureData?.file?.url) {
      console.log("No brochure file available");
      return;
    }

    try {
      // Fetch the file as a blob
      const response = await fetch(brochureData.file.url);
      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      const blob = await response.blob();

      // Extract filename from URL or use a default
      const urlParts = brochureData.file.url.split("/");
      const filename = urlParts[urlParts.length - 1].split("?")[0] || "brochure.pdf";

      // Create a temporary download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      // Fallback to opening in new window if download fails
      window.open(brochureData.file.url, "_blank");
    }
  };

  return (
    <div className="bg-blue-50">
      <div className="container mx-auto py-16 px-4 ">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Text and button */}
          <div>
            <h2 className="text-3xl md:text-4xl font-semibold text-darkBlue mb-6">
              Want to learn more?
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Download our brochure for detailed information about
              the Ministry and the development of the CBR Program.
            </p>
            <button
              onClick={handleDownload}
              className="px-8 py-3 border-2 border-lightBlue text-lightBlue rounded-full font-medium hover:bg-lightBlue hover:text-white transition-all"
            >
              Download Brochure
            </button>
          </div>

          {/* Right side - Brochure image */}
          <div className="relative flex justify-center ">
            <img
              src={BrochureImage}
              alt="CBR Brochure"
              className="w-full h-auto transform rotate-2"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WantToLearnMore;

